import styled from 'styled-components';

export const CloseModalButton = styled.button`
  position: absolute;
  top: 4px;
  right: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 4px;
  background-color: transparent;
  border: none;
  border-radius: 50%;
  outline: none;
`;

export const ModalTitle = styled.strong`
  // width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  padding-bottom: 12px;
  margin: 0px 5px;
  color: blue;
  border-bottom: 1px solid #888888;
`;

export const OrientationTitle = styled.strong`
  text-align: center;
  text-decoration: underline;
`;

export const OrientationImg = styled.img`
  height: 100px;
`;

export const OrientationDescription = styled.p`
  text-align: center;
  max-width: 200px;
`;

export const Text = styled.div`
  padding: 10px 15px;
`;
